import { create } from 'zustand';
import type { MeResponse, Role } from '@/shared/api/types';

/* Auth state for the admin web (bug #18).
 *
 * INVARIANT: nothing here is ever persisted to localStorage,
 *            sessionStorage, or IndexedDB. The access token lives in
 *            memory only; on full reload the app calls /v1/auth/refresh
 *            (using the HttpOnly cookie) to recover the session.
 *
 * The store also holds the current user profile so the layout can
 * render `username + role` without re-fetching on every render. */

export type AuthStatus = 'loading' | 'anonymous' | 'authenticated';

interface AuthState {
  status: AuthStatus;
  accessToken: string | null;
  user: MeResponse | null;
  setAccessToken: (token: string | null) => void;
  setUser: (user: MeResponse | null) => void;
  setStatus: (status: AuthStatus) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'loading',
  accessToken: null,
  user: null,
  setAccessToken: (accessToken) => set({ accessToken }),
  setUser: (user) => set({ user }),
  setStatus: (status) => set({ status }),
  reset: () => set({ status: 'anonymous', accessToken: null, user: null }),
}));

export function selectIsAdmin(role: Role | undefined): boolean {
  return role === 'ADMIN';
}
